// Share links: the source is deflated (CompressionStream, deflate-raw) and
// base64url-encoded into the URL hash as `#src=…`. Browsers without
// CompressionStream fall back to plain base64url under `#text=…`, which the
// decoder also accepts.

function toBase64Url(bytes) {
  let bin = '';
  for (let i = 0; i < bytes.length; i += 0x8000) {
    bin += String.fromCharCode.apply(null, bytes.subarray(i, i + 0x8000));
  }
  return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

function fromBase64Url(text) {
  const b64 = text.replace(/-/g, '+').replace(/_/g, '/') + '==='.slice((text.length + 3) % 4);
  const bin = atob(b64);
  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
  return bytes;
}

async function pipe(bytes, stream) {
  const response = new Response(new Blob([bytes]).stream().pipeThrough(stream));
  return new Uint8Array(await response.arrayBuffer());
}

export const canCompress = typeof CompressionStream === 'function' && typeof DecompressionStream === 'function';

/** Returns the hash fragment (without "#") for a source string. */
export async function encodeHash(source) {
  const bytes = new TextEncoder().encode(source);
  if (canCompress) {
    try {
      const deflated = await pipe(bytes, new CompressionStream('deflate-raw'));
      return 'src=' + toBase64Url(deflated);
    } catch {
      /* fall through */
    }
  }
  return 'text=' + toBase64Url(bytes);
}

/** Decodes a hash (with or without "#") to a source string, or null. */
export async function decodeHash(hash) {
  const h = (hash || '').replace(/^#/, '');
  if (!h) return null;
  const params = new URLSearchParams(h);
  try {
    const src = params.get('src');
    if (src) {
      if (!canCompress) return null;
      const inflated = await pipe(fromBase64Url(src), new DecompressionStream('deflate-raw'));
      return new TextDecoder().decode(inflated);
    }
    const text = params.get('text');
    if (text) return new TextDecoder().decode(fromBase64Url(text));
  } catch {
    return null;
  }
  return null;
}
